<template>
  <span v-html="value"></span>
</template>

<script>
export default {
  props: {
    item: Object,
    id: String,
    source: String,
  },
  computed: {
    value() {
      return this.$path(this.source || this.id, this.item) || '-'
    },
  },
}
</script>
